import { merge } from 'lodash-es';

import { GLOBAL_THEME } from './theme-components/global';
import { OVERRIDES_THEME } from './theme-components/overrides';

export const mainTheme = merge(OVERRIDES_THEME, GLOBAL_THEME);
